module.exports = __webpack_public_path__ + "img/Hilltop_Grill@1x.9395c4ef.webp";